import { api } from "@/shared/api/axios";
import { unwrap } from "@/shared/api/unwrap";
import { type User, type ApiResponse } from "@fysaro/domain";

export const getMeRequest = async (): Promise<User> => {
  const res = await api.get<ApiResponse<User>>("/auth/me");
  return unwrap(res.data);
};